/* eslint-disable indent */
/* eslint-disable max-len */
// eslint-disable-next-line max-len
import { observer } from 'mobx-react';
import ProfileSideBar from './components/ProfileSideBar';
import { MutilCalendarCustom, ReactNotifications, TooltipCustom } from '../../components';
import { DATE_TIME_FULL, DATE_YMD, DATE_YMD_ISO, DATE_YMD_JP, MSG, SETTING_TOOL_CERTIFICATE_STATUS, SETTING_TOOL_CERTIFICATE_STATUS_MAPPER, SETTING_TOOL_CERTIFICATE_TYPE } from '../../core/configs/constants';
import { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import { useStore } from '../../core/utils/hook';
import classNames from 'classnames';
import { handleKeyPressForNumber, handlePasteForNumber } from '../../core/utils/common';
import debounce from 'lodash.debounce';
import { useNavigate } from 'react-router-dom';
import { SYSTEM_PATH } from '../../core/configs/constants';

const ToolCertificateScreen = observer(() => {
    // store
    const {
        authStore: { userInfo },
        userStore: { userInfoHeader }
    } = useStore();
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const header = document.getElementById('header-site');
        if (!header) return;

        const updateHeight = () => {
            setHeaderHeight(header.offsetHeight);
        };

        // Follow initial height header
        updateHeight();

        // Follow resize header
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header);

        // Follow resize window
        window.addEventListener('resize', updateHeight);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);


    return (
        <div id='main' className='wrapper main-student-list main-Attended-couse main-purchasse-history tool-certificate-screen'>
            <div className="bres-cus" 
                style={{ position: 'sticky', zIndex: 50, top: `${headerHeight}px`, left: '0', width: '100%', backgroundColor: '#FFF'}}>
                <div className='container'>
                    <ul>
                        <li>
                            <a href='/'>
                                <img src='/images/icon-home.png' alt='' />
                            </a>
                        </li>
                        <li className='dash'>\</li>
                        <li>単位管理ツール</li>
                    </ul>
                </div>
            </div>
            <section className='top-student-list'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-2 col-lg-2 col-12 sidebar-tool-certificate'>
                            <ProfileSideBar />
                        </div>
                        <ToolCertificateComponent userId={userInfo.id} syncEnable={userInfoHeader?.syncEnable} />
                    </div>
                </div>
            </section>
        </div>
    );
});

export default ToolCertificateScreen;

export const ToolCertificateComponent = observer(({ isPopup = false, userId, syncEnable = false }) => {
    // hook
    const isFirstSetDataSettingTool = useRef('init');

    // store
    const {
        userStore: { toolCertificate, getToolCertificate, getSettingToolCertificate, setAttrObservable, saveToolCertificate, resetToolCertificate, getUserInfoHeader }
    } = useStore();

    // state
    const [typeSettingTool, setTypeSettingTool] = useState();
    const [startDate, setStartDate] = useState();
    const [disabledSearch, setDisabledSearch] = useState(false);
    const endDate = useMemo(() => {
        if (startDate) {
            switch (Number(typeSettingTool)) {
                case SETTING_TOOL_CERTIFICATE_TYPE.NEW:
                    return calculateDateAfterYear(startDate, 4);
                case SETTING_TOOL_CERTIFICATE_TYPE.UPDATE:
                    return calculateDateAfterYear(startDate, 3);
                default:
                    break;
            }
        }
        return '';
    }, [startDate, typeSettingTool])

    const { register, setValue, watch } = useForm({ mode: 'onChange' });

    const watchDataSettingTool = watch('dataSettingTool');

    // lifecycle
    useEffect(() => {
        getToolCertificate(userId);

        return () => {
            setAttrObservable('toolCertificate', null);
        }
    }, [])

    useEffect(() => {
        if (toolCertificate) {
            const { type, startDate, value } = toolCertificate;

            setTypeSettingTool(String(type));
            setStartDate(startDate);
            if (!disabledSearch) {
                setValue('dataSettingTool', value, { shouldValidate: true });
                setDisabledSearch(true);
                isFirstSetDataSettingTool.current = 'first-change';

            } else {
                let data;
                const formatValue = formatDataSettingTool(value);
                if (type == SETTING_TOOL_CERTIFICATE_TYPE.NEW) {
                    data = verifyDataSettingToolNew(formatValue);
                } else {
                    data = verifyDataSettingToolUpdate(formatValue);
                }

                setValue('dataSettingTool', data, { shouldValidate: true });

                isFirstSetDataSettingTool.current = 'on-save';
            }
        } else {
            setValue('dataSettingTool', null, { shouldValidate: true });
        }
    }, [toolCertificate])

    useEffect(() => {
        if (isFirstSetDataSettingTool.current === 'init' || isFirstSetDataSettingTool.current === 'first-change') {
            return;
        }
        const debounced = debounce(() => {
            onSaveToolCertificate();
        }, 1000);

        debounced();

        return () => debounced.cancel();
    }, [JSON.stringify(watchDataSettingTool)])

    // function
    const onChangeTypeSettingTool = (e) => {
        setTypeSettingTool(e.target.value);
    }

    const onSubmitGetSettingTool = async () => {
        if (!disabledSearch) {
            await getSettingToolCertificate({
                id: userId,
                payload: { type: typeSettingTool, startDate }
            });
            setDisabledSearch(true);
        }
    }

    const verifyDataSettingToolNew = (data, startIndex = 0) => {
        if (!data?.length) return data;

        const newData = JSON.parse(JSON.stringify(data));

        for (let index = startIndex; index < newData.length; index++) {
            const element = newData[index];

            element.totalCourseCompletion = Number((element.courseCompletion || 0)) + Number((element.othersCourseCompletion || 0)) + Number((element.eiCurriculumCompletion || 0));
            let totalCourseCompletionBeforeElement = 0;
            element.status = null;
            if (index > 0) {
                totalCourseCompletionBeforeElement = newData.slice(0, index).reduce((prev, cur) => prev + cur.totalCourseCompletion, 0);
            }
            if (element.totalCourseCompletion + totalCourseCompletionBeforeElement >= 40) {
                element.status = SETTING_TOOL_CERTIFICATE_STATUS.COMPLETED;
            }

            if (index === newData.length - 1 &&
                element.startDate &&
                moment().isSameOrAfter(moment(element.startDate).add(1, 'year'), 'date') &&
                element.status !== SETTING_TOOL_CERTIFICATE_STATUS.COMPLETED
            ) {
                element.status = SETTING_TOOL_CERTIFICATE_STATUS.FAILED
            }
        }

        return newData;
    }

    const verifyDataSettingToolUpdate = (data, startIndex = 0) => {
        if (!data?.length) return data;

        const newData = JSON.parse(JSON.stringify(data));

        for (let index = startIndex; index < newData.length; index++) {
            const element = newData[index];

            element.totalCourseCompletion = Number((element.courseCompletion || 0)) + Number((element.othersCourseCompletion || 0)) + Number((element.eiCurriculumCompletion || 0));
            if (element.totalCourseCompletion < 5) {
                element.status = SETTING_TOOL_CERTIFICATE_STATUS.NOT_COMPLETE;
            } else {
                if (index !== newData.length - 1) {
                    element.status = SETTING_TOOL_CERTIFICATE_STATUS.WARNING_COMPLETE;
                } else {
                    let totalCourseCompletionBeforeElement = 0;
                    if (index > 0) {
                        totalCourseCompletionBeforeElement = newData.slice(0, index).reduce((prev, cur) => prev + cur.totalCourseCompletion, 0);
                    }
                    if (element.totalCourseCompletion + totalCourseCompletionBeforeElement < 30) {
                        element.status = SETTING_TOOL_CERTIFICATE_STATUS.WARNING_COMPLETE;
                    } else {
                        element.status = SETTING_TOOL_CERTIFICATE_STATUS.COMPLETED;
                    }
                }
            }

            if (index === newData.length - 1 &&
                element.startDate &&
                moment().isSameOrAfter(moment(element.startDate).add(1, 'year'), 'date') &&
                element.status !== SETTING_TOOL_CERTIFICATE_STATUS.COMPLETED
            ) {
                element.status = SETTING_TOOL_CERTIFICATE_STATUS.FAILED
            }
        }

        return newData;
    }

    const updateStatusDataSettingTool = (startIndex = 0) => {
        let data;
        if (typeSettingTool == SETTING_TOOL_CERTIFICATE_TYPE.NEW) {
            data = verifyDataSettingToolNew(watchDataSettingTool, startIndex);
        } else {
            data = verifyDataSettingToolUpdate(watchDataSettingTool, startIndex);
        }

        if (data?.length === watchDataSettingTool.length) {
            for (let index = startIndex; index < watchDataSettingTool.length; index++) {
                const originData = watchDataSettingTool[index];
                const newData = data[index];
                if (originData.status !== newData.status) {
                    setValue(`dataSettingTool.${index}.status`, newData.status);
                }
            }
        }
    }

    const onChangeOthersCourseComplete = (value, index) => {
        isFirstSetDataSettingTool.current = 'on-save';
        if (value > 99) {
            value = 99;
            setValue(`dataSettingTool.${index}.othersCourseCompletion`, value);
        }
        const totalCourseCompletion = Number(watchDataSettingTool[index].courseCompletion) +
            Number(watchDataSettingTool[index]?.eiCurriculumCompletion || 0) +
            Number(value || 0);
        setValue(`dataSettingTool.${index}.totalCourseCompletion`, totalCourseCompletion);
        updateStatusDataSettingTool(index);
        // onDebounceAutoSaveToolCertificate();
    }

    function calculateDateAfterYear(date, years = 1, formatDate = DATE_YMD_JP) {
        if (!date) return '';
        return moment(date).add(years, 'years').subtract(1, 'days').format(formatDate);
    }

    const formatDataSettingTool = (data) => {
        if (!data?.length) return data;

        const newData = JSON.parse(JSON.stringify(data));
        const result = [newData[0]];
        for (let index = 1; index < newData.length; index++) {
            const element = newData[index];

            if (
                !isTargetPeriodContainsCurrentDate(element.startDate)
            ) {
                element.disabled = true;
                element.othersCourseCompletion = '';
                element.totalCourseCompletion = element.courseCompletion + Number(element?.eiCurriculumCompletion || 0);
            } else {
                element.disabled = false;
            }
            result.push(element);
        }

        return result;
    }

    const onSaveToolCertificate = async () => {
        if (watchDataSettingTool?.length) {
            const value = formatDataSettingTool(watchDataSettingTool);

            const payload = {
                type: Number(typeSettingTool),
                startDate,
                value
            }

            const res = await saveToolCertificate({ id: userId, payload });

            if (res) {
                if (!isPopup) {
                    getUserInfoHeader({}, true);
                }
                getToolCertificate(userId, true);
                ReactNotifications('success', MSG['tool.certificate.update.success']);
            }
        }
    }

    const onResetToolCertificate = async () => {
        if (toolCertificate) {
            const res = await resetToolCertificate(userId);

            if (res) {
                setTypeSettingTool('');
                setStartDate(null);
                setDisabledSearch(false);
                if (!isPopup) {
                    getUserInfoHeader({}, true);
                }
                getToolCertificate(userId, true);
            }
        }
    }

    const isTargetPeriodContainsCurrentDate = (startDate) => {
        const endDate = moment(startDate).add(1, 'year').subtract(1, 'day');
        const currentDate = moment();
        if ((moment(currentDate).isSameOrAfter(moment(startDate), 'date') && moment(currentDate).isSameOrBefore(endDate, 'date'))
            || moment(currentDate).isAfter(endDate, 'date')) {
            return true;
        }
        return false;
    }

    return (
        <div className={classNames(isPopup ? '' : 'col-md-10 col-lg-10 col-12 container-tool-certificate')}>
            <div className={classNames('search-tool-certificate content-top-student pd-tb-25', isPopup && 'mt-0')}>
                <div className='row'>
                    <div className='col-12 tool-certificate-input-type d-flex flex-gap-20'>
                        <div className='d-flex' style={{ minWidth: '178px' }}>
                            <div className='d-flex'>
                                <input type='radio' id='newRecord'
                                    name='typeSettingTool'
                                    value={SETTING_TOOL_CERTIFICATE_TYPE.NEW}
                                    onChange={onChangeTypeSettingTool}
                                    checked={typeSettingTool == SETTING_TOOL_CERTIFICATE_TYPE.NEW}
                                    disabled={disabledSearch} />
                                <label className='font-bold' role='button' htmlFor='newRecord'>新規</label>
                            </div>
                            <div className='d-flex mg-l-50'>
                                <input type='radio' id='updateRecord'
                                    name='typeSettingTool'
                                    value={SETTING_TOOL_CERTIFICATE_TYPE.UPDATE}
                                    onChange={onChangeTypeSettingTool}
                                    checked={typeSettingTool == SETTING_TOOL_CERTIFICATE_TYPE.UPDATE}
                                    disabled={disabledSearch} />
                                <label className='font-bold' role='button' htmlFor='updateRecord'>更新</label>
                            </div>
                        </div>
                        <div className='text-error font-bold text-14 flex-grow' style={{ maxWidth: '666px' }}>
                            ※新規の場合は、PECSにて「認定申請」を行った日から4年前まで遡って4年以内に40単位が必要となりますので、こちらのツールはあくまで目安としてご利用ください。
                        </div>
                    </div>
                    <div className='col-12 mg-t-25'>
                        <label className='col-12 font-bold'>研修単位取得期間</label>
                        <div className='mg-t-10 d-flex justify-content-between align-items-center flex-wrap'>
                            <div className='col-md-9 col-12 d-flex justify-content-between align-items-center flex-wrap'>
                                <MutilCalendarCustom
                                    className={'col-sm-5 col-12'}
                                    date={startDate || null}
                                    onChange={date => setStartDate(date ? moment(date).format(DATE_YMD_ISO) : null)}
                                    dateDisplayFormat={DATE_YMD_JP}
                                    disabled={!typeSettingTool || disabledSearch}
                                    minDate={new Date(typeSettingTool == SETTING_TOOL_CERTIFICATE_TYPE.NEW ?
                                        moment().add(1, 'day').subtract(4, 'year').format(DATE_YMD) :
                                        moment().add(1, 'day').subtract(3, 'year').format(DATE_YMD)
                                    )}
                                    maxDate={new Date()}
                                />
                                <div>~</div>
                                <input className='calendar-input col-sm-5 col-12' value={endDate} disabled readOnly />
                            </div>
                            <input
                                type='submit'
                                className='submit-search'
                                value='設定' onClick={onSubmitGetSettingTool}
                                disabled={disabledSearch || !typeSettingTool || !startDate} />
                        </div>
                        <div className='text-error font-bold mg-t-10 text-14'>※研修単位取得期間の開始日をカレンダーから選択してください。終了日は自動的に表示されます。</div>
                    </div>
                </div>
            </div>
            <div className='content-tool-certificate content-student-list'>
                {
                    toolCertificate?.createdAt && (
                        <div
                            className='font-semibold text-14 d-flex justify-content-end'
                            style={{ color: '#7f7f7f' }}
                        >{`設定日: ${moment(toolCertificate?.createdAt).format(DATE_TIME_FULL)} | 最終更新日時: ${moment(toolCertificate?.updatedAt).format(DATE_TIME_FULL)}`}</div>
                    )
                }
                {
                    watchDataSettingTool?.length > 0 &&
                    <>
                        <div className={classNames('table-table', isPopup && 'mt-0 table-popup')}>
                            <div className='tool-certificate-warning'>
                                {
                                    typeSettingTool == SETTING_TOOL_CERTIFICATE_TYPE.NEW ?
                                        '4年で40単位が必要' :
                                        '毎年最低5単位。3年で30単位が必要'
                                }
                            </div>
                            <table className={classNames('border-bottom-0',
                                typeSettingTool == SETTING_TOOL_CERTIFICATE_TYPE.NEW ? 'table-tool-certificate-new'
                                    : 'table-tool-certificate-update')}>
                                <tr>
                                    {watchDataSettingTool.map((_, index) => <td key={index}>{index + 1}年目</td>)}
                                </tr>
                                <tr>
                                    {
                                        watchDataSettingTool.map((item, index) => (
                                            <td key={index} className='bg-white'>
                                                {
                                                    item?.startDate ?
                                                        // eslint-disable-next-line max-len
                                                        `${moment(item.startDate).format(DATE_YMD)} ~ ${calculateDateAfterYear(item.startDate, 1, DATE_YMD)}`
                                                        : ''
                                                }
                                            </td>
                                        ))
                                    }
                                </tr>
                                <tr>
                                    {
                                        watchDataSettingTool.map((item, index) => (
                                            <td key={index} className='bg-white'>
                                                {item?.disabled ? '-' : (item?.courseCompletion || 0)}
                                            </td>
                                        ))
                                    }
                                </tr>

                                {/* IBT: only shown for students whose account is synced with IBT */}
                                {syncEnable && (
                                    <>
                                        <tr className='border-0'>
                                            <td className='text-start border-0 pd-l-0 bg-white'
                                                colSpan={watchDataSettingTool.length}>
                                                <div className='font-bold'>＜elephamt IBT&gt;</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            {
                                                watchDataSettingTool.map((item, index) => (
                                                    <td key={index} className='bg-white'>
                                                        {item?.disabled ? '-' : (item?.eiCurriculumCompletion || 0)}
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                    </>
                                )}

                                {/* Other */}
                                <tr className='border-0'>
                                    <td className='text-start border-0 pd-l-0 bg-white'
                                        colSpan={watchDataSettingTool.length}>
                                        <div className='font-bold'>＜elephamt以外で取得した単位数を入力してください。&gt;</div>
                                    </td>
                                </tr>
                                <tr>
                                    {
                                        watchDataSettingTool.map((item, index) => (
                                            <td key={index} className='bg-white'>
                                                {
                                                    item?.disabled ?
                                                        <input value={'-'} disabled readOnly
                                                            className='w-100 tool-certificate-input-course text-center pd-0' /> :
                                                        <input {...register(`dataSettingTool.${index}.othersCourseCompletion`, {
                                                            onChange: e => onChangeOthersCourseComplete(e.target.value, index)
                                                        })}
                                                            onKeyPress={handleKeyPressForNumber}
                                                            onPaste={handlePasteForNumber}
                                                            onWheel={(e) => e.target.blur()}
                                                            type='number'
                                                            max={100}
                                                            min={0}
                                                            className='w-100 tool-certificate-input-course text-center pd-0'
                                                        />
                                                }

                                            </td>
                                        ))
                                    }
                                </tr>
                                <tr className='border-0'>
                                    <td className='text-start border-0 pd-l-0 bg-white'
                                        colSpan={watchDataSettingTool.length}>
                                        <div className='font-bold'>合計</div>
                                    </td>
                                </tr>
                                <tr>
                                    {
                                        watchDataSettingTool.map((item, index) => (
                                            <td key={index} className='bg-white'>
                                                <div className='font-bold'>
                                                    {item?.disabled ? '-' : (item?.totalCourseCompletion || 0)}
                                                </div>
                                            </td>
                                        ))
                                    }
                                </tr>
                                <tr>
                                    {
                                        watchDataSettingTool.map((item, index) => (
                                            <td key={index} className='bg-white border-0'>
                                                {
                                                    SETTING_TOOL_CERTIFICATE_STATUS_MAPPER[item?.status] ?
                                                        !item?.disabled &&
                                                        // <img src={SETTING_TOOL_CERTIFICATE_STATUS_MAPPER[item.status].IMG}
                                                        //     width={20}
                                                        // /> 
                                                        // eslint-disable-next-line max-len
                                                        <span className='fw-bolder' style={{ 'color': SETTING_TOOL_CERTIFICATE_STATUS_MAPPER[item.status].TEXT_COLOR }}>
                                                            {SETTING_TOOL_CERTIFICATE_STATUS_MAPPER[item.status].LABEL}
                                                        </span>
                                                        : (
                                                            <span className='fw-bolder' style={{ 'color': 'red' }}>-</span>
                                                        )
                                                }
                                            </td>
                                        ))
                                    }
                                </tr>
                            </table>
                        </div>

                        <div className='text-error font-bold mg-t-10 text-14'>
                            <div>&lt;英字表示についての説明&gt;</div>
                            <div>アルファベット表示は本サイトおよびご自身で入力された単位数をもとに計算</div>
                            <div>した<u>目安となりますので予めご了解ください。</u></div>
                            <div>正確な情報は日本薬剤師研修センターのPECSにてご確認いただけます</div>
                            <div>ようお願いいたします。</div>
                            <div>A：新規の場合は合計40単位以上、更新の場合は3年目で 30単位以上</div>
                            <div>となった時点で表示。</div>
                            <div>B：更新の場合に5単位以上となった時点で表示。</div>
                            <div>C：更新の場合に5単位未満の時点で表示。</div>
                            <div>D：研修認定期間の最終日までにAにならなかった場合に表示。</div>
                        </div>

                        <div className='tool-certificate-button d-flex 
                                justify-content-center align-items-center flex-gap-40 flex-wrap mg-t-75 mg-b-30'>
                            <TooltipCustom
                                title={
                                    <div>
                                        <div>情報が全てリセットされますが、</div>
                                        <div>よろしいですか？</div>
                                    </div>
                                }
                            >
                                <button type='button' className='btn-1' onClick={onResetToolCertificate}>
                                    情報リセット
                                </button>
                            </TooltipCustom>
                        </div>
                    </>
                }
            </div>
        </div>
    )
})
